module.exports = __webpack_public_path__ + "img/grillentanz5.46e7e387.jpg";